import React from "react";
import {Trans} from "react-i18next";

// Libs
import {boxShadow} from "../libs/theme-lib";
import searchImage from "../../assets/undraw_Web_search_re_efla.svg";
import emptyImage from "../../assets/undraw_empty_xct9.svg";

// Components
import VirtualizedTable from "./virtualized-table";

const RenderContent = (props) => {

    const {
        data,
        showWelcomeMessage,
        welcomeMessage = "welcomeMessage",
        noDataMessage = "noDataMessage",
        nameCollection,
        renderHeader,
        renderHtml,
        renderHeaderText,
        renderHeaderValues,
        renderHeaderComponents,
        style = {},
        config,
        columns
    } = props;

    return (
        <div style={{
            backgroundColor: "white",
            boxShadow: boxShadow,
            padding: 15,
            flex: 1,
            display: "flex",
            flexDirection: "column",
            ...style
        }}>
            {/* show whelcome message */}
            {showWelcomeMessage && (
                <div style={{
                    display: "block",
                    margin: "auto"
                }}>
                    <img
                        src={searchImage}
                        alt="Imagen filtros"
                        style={{
                            maxWidth: "300px",
                            display: "block",
                            margin: "auto auto 40px auto"
                        }}
                    />
                    <div style={{fontWeight: 100, fontSize: 18}}>
                        <Trans
                            i18nKey={"renderContent:" + welcomeMessage}
                            values={{nameCollection: nameCollection}}
                            components={[<strong>string</strong>]}
                        />
                    </div>
                </div>
            )}
            {/* show no data found if get an empty array of data */}
            {data.length === 0 && !showWelcomeMessage && (
                <div style={{
                    display: "block",
                    margin: "auto"
                }}>
                    <img
                        src={emptyImage}
                        alt="Imagen filtros"
                        style={{
                            maxWidth: "300px",
                            display: "block",
                            margin: "auto auto 40px auto"
                        }}
                    />
                    <div style={{fontWeight: 100, fontSize: 18}}>
                        <Trans 
                            i18nKey={"renderContent:" + noDataMessage}
                            values={{nameCollection: nameCollection}}
                            components={[<strong>string</strong>]}
                        />
                    </div>
                </div>
            )}
            {/* render virtualize table */}
            {data.length >= 1 && !showWelcomeMessage && (
                <>
                    {renderHeader && renderHeaderText && (
                        <div style={{marginBottom: 15, fontSize: 18, fontWeight: 100}}>
                            <Trans
                                i18nKey={renderHeaderText}
                                values={renderHeaderValues}
                                components={renderHeaderComponents}
                            />
                        </div>
                    )}
                    {renderHeader && renderHtml && (
                        <>{renderHtml}</>
                    )}
                    <VirtualizedTable
                        data={data}
                        columns={columns}
                        config={config}
                    />
                </>
            )}
        </div>
    );
};

export default RenderContent;